<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Account Domains</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-globe me-1" style="color: #00A0C1;"></i>
                  Add and verify domains associated with this account.
               </small>
            </div>
         </div>
      </div>

      <AccountDomains />
   </div>
</template>

<script>
import AccountDomains from '@/components/ExtensionConfiguration/Domains/Domains.vue';

export default {
   components: {
      AccountDomains,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>